import moment from 'moment';
import { REGROUPEMENT, TYPE_COMMANDE } from '@/configuration/devisConf';

export default function genererCritereRecherchePrevisionnelCBA() {
  return {
    auto: '',
    societeId: null,
    agencesIdProduit: [],
    logisticable: true,
    aIntegrerDansLaLogistique: true,
    sens: '',
    nePasReafficher: true,
    types: [REGROUPEMENT],
    typesProduits: [],
    bloqueOuInterne: true,
    typesDevisCommandeFacture: [TYPE_COMMANDE],
    codesDcf: [],
    commercialId: null,
    assistantId: null,
    instructionPose: '',
    afficheLivre: null,
    theme: '',
    libelleProduit: '',
    villes: [],
    dates: {
      dateDebut: moment().toDate(),
      dateFin: moment().add(5, 'weeks').toDate(),
    },
    qteMinFacesVendues: null,
    qteMaxFacesVendues: null,
    dateAnneeSemaine: null,
    jourDepart: [],
  };
}
